module.exports = __webpack_public_path__ + "img/skull_1.6263275a.png";